<template>
  <div style='width: 100%;height: 100%;position: relative;min-width: 1100px' class='home_content_div'>
    <div class='home_top_div'>
      <div class='top_img_div'><img class='div1-lRImg1' :src='topImg2'></div>
      <div class='top_img_div'><img class='div1-lRImg2' :src='topImg1'> <img class='div1-lRImg3' :src='topImg3'></div>
      <div><img class='div1-lRImg4' :src='topImg4'></div>
    </div>
    <div class='home_top_div2'>
      <div class='top_img_div2in1'><img :src='topImg2in1' class='div2-lRImg1'></div>
      <div class='top_img_div2 div2-lRDiv1'><img class='div2-lRImg' :src='topImg2in2'></div>
      <div class='top_img_div2 div2-lRDiv2'><img class='div2-lRImg' :src='topImg2in3'></div>
      <div class='top_img_div2 div2-lRDiv3'><img class='div2-lRImg' :src='topImg2in4'></div>
      <div class='top_img_div2 div2-lRDiv4'><img class='div2-lRImg' :src='topImg2in5'></div>
    </div>
    <div class='home_top_div3'>
      <div class='top_img_div3'><img :src='topImg3in2' class='div3-lRImg1'></div>
      <div class='top_img_div3'>
        <img :src='topImg3in4' class='div3-lRImg2'>
        <img :src='topImg3in1' class='div3-lRImg3'>
      </div>
      <div class='top_img_div3'><img class='div3-lRImg1' :src='topImg3in3'></div>
    </div>
    <div class='home_top_div4'>
      <div class='home-top-padding'>
        <div class='top_img_div4'><img class='div4-lRImg1' :src='topImg4in1'></div>
        <div class='top_img_div4'><img class='div4-lRImg1' :src='topImg4in2'></div>
      </div>
      <div>
        <div class='top_img_div4'><img class='div4-lRImg2' :src='topImg4in3'></div>
        <div class='top_img_div4'><img class='div4-lRImg2' :src='topImg4in4'></div>
        <div class='top_img_div4'><img class='div4-lRImg2' :src='topImg4in5'></div>
      </div>
    </div>
    <div class='home_top_div4-1'>
      <div class='top_img_div4-1'><img class='div4-lRImg3' :src='topImg4in6'></div>
    </div>
    <div class='home_top_div5'>
      <div style='padding-top: 60px'>
        <div class='home_img_div5 hover-box' @mouseenter="hovering = true" @mouseleave="hovering = false"><img class='div5-lRImg1' :src='topImg5in1'></div>
        <div class='home_img_div5 hover-box' @mouseenter="hovering = true" @mouseleave="hovering = false"><img class='div5-lRImg1' :src='topImg5in2'></div>
      </div>
      <div>
        <div class='home_img_div5 hover-box' @mouseenter="hovering = true" @mouseleave="hovering = false"><img class='div5-lRImg1' :src='topImg5in3'></div>
        <div class='home_img_div5 hover-box' @mouseenter="hovering = true" @mouseleave="hovering = false"><img class='div5-lRImg1' :src='topImg5in4'></div>
        <div class='home_img_div5 hover-box' @mouseenter="hovering = true" @mouseleave="hovering = false"><img class='div5-lRImg1' :src='topImg5in5'></div>
      </div>
      <div>
        <div class='home_img_div5'><img class='div5-lRImg2' :src='topImg5in6'></div>
      </div>
      <div>
        <div class='line-div'>
          <div></div><span>认知自我</span>
          <img class='div5-lRImg3' :src='topImg5in7'><span>选择未来</span>
          <div></div>
        </div>
      </div>
    </div>
    <Bottom />
    <ElDialog title="购买商品" v-model="purchaseDialogVisible" width="30%">
      <div>
        <img :src="selectedProduct.img" alt="" style="width: 100%">
        <h3>{{ selectedProduct.title }}</h3>
        <p>价格：{{ selectedProduct.price }}</p>
        <ElForm :model="orderForm" ref="orderForm">
          <ElFormItem label="姓名" prop="name">
            <ElInput v-model="orderForm.name" placeholder="请输入您的姓名"></ElInput>
          </ElFormItem>
          <ElFormItem label="电话" prop="phone">
            <ElInput v-model="orderForm.phone" placeholder="请输入您的电话"></ElInput>
          </ElFormItem>
          <ElFormItem label="地址" prop="address">
            <ElInput v-model="orderForm.address" placeholder="请输入您的地址"></ElInput>
          </ElFormItem>
        </ElForm>
      </div>
      <div style="text-align: right; margin-top: 20px;">
        <ElButton @click="closePurchaseDialog">取消</ElButton>
        <ElButton type="primary" @click="confirmPurchase">确认购买</ElButton>
      </div>
    </ElDialog>

    <ElDialog title="支付" v-model="paymentDialogVisible" width="30%">
      <div style="text-align: center;">
        <h3>请使用微信扫描下方二维码完成支付</h3>
        <img :src="qrCodeUrl" alt="二维码" style="width: 100%; max-width: 200px; margin: 20px 0;">
        <ElButton type="primary" @click="closePaymentDialog">完成支付</ElButton>
      </div>
    </ElDialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import Navbar from '@/layout/components/Navbar'
import Bottom from '@/layout/components/Bottom_app'
import { useRoute, useRouter } from 'vue-router'
import { ElDialog, ElForm, ElFormItem, ElInput, ElButton, ElMessage } from 'element-plus'

const route = useRoute()
const store = useStore()
const name = ref(store.getters.userInfo.name)
// localStorage.setItem('yq_client_token', 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjUwOCwicm9sZUlkcyI6W10sImNsaWVudElwIjoiOjoxIiwiYXBwS2V5Ijoid2VpbGFpIiwidG9rZW4iOm51bGwsImV4cCI6MTcxMDgzNjY3N30.8IHE_ii7IKRvwSwL1HmiMJ0gLChpToelggnxMozEkSQ')
// localStorage.setItem('timeStamp', '1710750277497')
const logout = () => {
  store.dispatch('user/logout')
}
const topImg1 = require('../../assets/images/home/1-1.png')
const topImg2 = require('../../assets/images/home/1-2.png')
const topImg3 = require('../../assets/images/home/1-3.png')
const topImg4 = require('../../assets/images/home/1-4.png')

const topImg2in1 = require('../../assets/images/home/2-1.png')
const topImg2in2 = require('../../assets/images/home/2-2.png')
const topImg2in3 = require('../../assets/images/home/2-3.png')
const topImg2in4 = require('../../assets/images/home/2-4.png')
const topImg2in5 = require('../../assets/images/home/2-5.png')

const topImg3in1 = require('../../assets/images/home/3-1.png')
const topImg3in2 = require('../../assets/images/home/3-2.png')
const topImg3in3 = require('../../assets/images/home/3-3.png')
const topImg3in4 = require('../../assets/images/home/3-4.png')

const topImg4in1 = require('../../assets/images/home/4-1.png')
const topImg4in2 = require('../../assets/images/home/4-2.png')
const topImg4in3 = require('../../assets/images/home/4-3.png')
const topImg4in4 = require('../../assets/images/home/4-4.png')
const topImg4in5 = require('../../assets/images/home/4-5.png')
const topImg4in6 = require('../../assets/images/home/4-6.png')

const topImg5in1 = require('../../assets/images/home/5-1.png')
const topImg5in2 = require('../../assets/images/home/5-2.png')
const topImg5in3 = require('../../assets/images/home/5-3.png')
const topImg5in4 = require('../../assets/images/home/5-4.png')
const topImg5in5 = require('../../assets/images/home/5-5.png')
const topImg5in6 = require('../../assets/images/home/5-6.png')
const topImg5in7 = require('../../assets/images/home/5-7.png')
const hovering = ref(false)

const isUserInfo = ref(false)
if (name.value !== null && name.value !== undefined && name.value !== '') {
  isUserInfo.value = true
}

// 设置侦听器
onMounted(() => {
  // const Urlparam = new URLSearchParams(window.location.search)
  // console.log(Urlparam.get('param'))
  // console.log('-------')
  // window.addEventListener('message', (event) => {
  //   // if (event.origin)
  //   console.log(event.data.param)
  // })
})

// 商品数据
const products = ref([
    {
        img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MM6F3?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
        title: 'Native Union Pocket USB-C 至 USB-C 连接线 - 多彩配色',
        price: 'RMB 248',
        tag: '',
        provider: ''
    },
    {
        img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/HQ7F2?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
        title: 'Satechi 磁力卡包支架 (兼容 MagSafe) - 暗紫色/深青色',
        price: 'RMB 398',
        tag: 'Apple 独家提供',
        provider: 'Apple'
    },
    {
        img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MM6G3?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
        title: 'Nimble Champ 10k 移动电源 - 深青色',
        price: 'RMB 548',
        tag: 'Apple 独家提供',
        provider: 'Apple'
    },
    {
        img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/ML763?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
        title: 'Apple MagSafe 充电器',
        price: 'RMB 329',
        tag: '',
        provider: ''
    },
    {
        img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MN653?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
        title: 'Belkin 3合1无线充电板',
        price: 'RMB 1098',
        tag: '',
        provider: ''
    },
    {
        img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MME73?wid=400&hei=400&fmt=jpeg&qlt=95&.v=1645138486317',
        title: 'AirPods (第三代)',
        price: 'RMB 1399',
        tag: '',
        provider: ''
    }
])

const books = ref([
  {
    img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/product-image?wid=400&hei=400&fmt=jpeg&qlt=95',
    title: 'Herschel Burrard Organizer Tech 收纳包 - 多彩配色',
    author: 'Apple 独家提供',
    price: 'RMB 498',
    colors: ['#2196F3', '#FFC107']
  },
  {
    img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/airpods-4-case?wid=400&hei=400&fmt=jpeg&qlt=95',
    title: 'Tech21 半透明 EvoPop AirPods 4 保护壳 - 珊瑚色',
    author: 'Apple 独家提供',
    price: 'RMB 298',
    colors: ['#FF6B6B']
  },
  {
    img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/popsocket-grip?wid=400&hei=400&fmt=jpeg&qlt=95',
    title: 'PopSockets MagSafe Grip 磁吸手柄 (适用于 iPhone) - 蓝莓色',
    author: 'Apple 独家提供',
    price: 'RMB 298',
    colors: ['#9C27B0', '#3F51B5', '#E91E63', '#9E9E9E', '#212121']
  },
  {
    img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/book-cover?wid=400&hei=400&fmt=jpeg&qlt=95',
    title: '设计思维手册',
    author: '苹果设计团队',
    price: 'RMB 128',
    colors: []
  },
  {
    img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/programming-book?wid=400&hei=400&fmt=jpeg&qlt=95',
    title: 'Swift 编程指南',
    author: 'Apple 开发者',
    price: 'RMB 158',
    colors: []
  },
  {
    img: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/creativity-book?wid=400&hei=400&fmt=jpeg&qlt=95',
    title: '创意思维与实践',
    author: 'Apple 教育团队',
    price: 'RMB 98',
    colors: []
  }
])

// 购买弹窗相关
const purchaseDialogVisible = ref(false)
const paymentDialogVisible = ref(false)
const selectedProduct = ref(null)
const orderForm = ref({
  name: '',
  phone: '',
  address: ''
})

// 购买按钮点击事件
const handlePurchase = (product) => {
  selectedProduct.value = product
  purchaseDialogVisible.value = true
}

// 确认购买
const confirmPurchase = () => {
  if (!orderForm.value.name || !orderForm.value.phone || !orderForm.value.address) {
    ElMessage.warning('请填写完整信息')
    return
  }
  purchaseDialogVisible.value = false
  paymentDialogVisible.value = true
}

// 关闭弹窗
const closePurchaseDialog = () => {
  purchaseDialogVisible.value = false
  orderForm.value = { name: '', phone: '', address: '' }
}

const closePaymentDialog = () => {
  paymentDialogVisible.value = false
  selectedProduct.value = null
}

// 生成二维码（这里使用一个示例二维码）
const qrCodeUrl = ref('https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=payment-code-12345')
</script>

<style lang="scss" scoped>
.navbarHome {
  height: $navbarHeight;
  overflow: hidden;
  position: fixed;
  width: 100%;
  background: $background-color-primary;
  //box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-bottom: $border-base;
  text-align: center;
  z-index: 1000;
  .newbtn{
    margin-top:9px;
    margin-left:25px;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    // hover 动画
    transition: background 0.5s;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    align-items: center;
    display: inline-block;
    padding-right: 16px;
    position: fixed;
    /* top: -160px; */
    /* left: 300px; */
    right: 0;
    top: 0;

    :deep(.right-menu-item) {
      display: inline-block;
      padding: 0 5px 0 0;
      font-size: 24px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
        line-height: 60px;

        //&:hover {
        //  background: rgba(0, 0, 0, 0.025);
        //}
      }
    }

    :deep(.avatar-container) {
      cursor: pointer;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        .el-avatar {
          --el-avatar-background-color: none;
          margin-right: 12px;
        }
      }
    }
  }

  .avatar-container{
    line-height:$navbarHeight;

    .avatar-wrapper {
      margin-top:0px !important;
    }
  }
}
//.line-div{
//  display: flex;
//  justify-content: center;
//  align-items: center;
//  div {
//    width: 260px;
//    border-top: 1px solid white;
//  }
//}
//.line-div span{
//  color: white;
//  font-size: 25px;
//  margin: 0 28px;
//  font-weight: bold;
//}

</style>
